import React from 'react';
import { useTranslation } from 'react-i18next';
import { WalletPotten } from '../WalletPotten';
import type { Wallet } from '../../services/medewerkerApi';

const eur = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });

/** POP-budget-wallet: 🟢 beschikbaar bedrag + meter (of de twee potten bij de Payroll Bridge). */
export const WalletMeter: React.FC<{ wallet: Wallet }> = ({ wallet }) => {
  const { t } = useTranslation('medewerker');
  if (!wallet.actief) {
    return <p className="text-sm text-gray-500">{t('academy.nietActief', { defaultValue: 'Nog niet geactiveerd door je werkgever' })}</p>;
  }
  if (wallet.potten) {
    return <WalletPotten wallet={wallet} />;
  }
  if (wallet.model === 'on_demand') {
    return (
      <p className="text-sm text-green-800 font-medium">
        <span aria-hidden="true">🟢</span> {t('academy.onbeperkt', { defaultValue: 'Onbeperkt budget (on demand)' })}
      </p>
    );
  }
  const totaal = wallet.budget_totaal ?? 0;
  const pct = totaal > 0 ? Math.min(100, Math.round((wallet.budget_gebruikt / totaal) * 100)) : 0;
  return (
    <div>
      <p className="text-sm text-green-800 font-medium">
        <span aria-hidden="true">🟢</span>{' '}
        {t('academy.budgetBeschikbaarKort', { defaultValue: '{{bedrag}} beschikbaar', bedrag: eur.format(wallet.budget_resterend ?? 0) })}
      </p>
      <div className="mt-2 h-1.5 w-full rounded-full bg-gray-200 overflow-hidden" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={pct}>
        <div className="h-full bg-green-500 rounded-full" style={{ width: `${pct}%` }} />
      </div>
      <p className="text-xs text-gray-500 mt-1">
        {t('academy.gebruiktVan', {
          defaultValue: '{{gebruikt}} van {{totaal}} gebruikt',
          gebruikt: eur.format(wallet.budget_gebruikt),
          totaal: eur.format(totaal),
        })}
      </p>
    </div>
  );
};

export default WalletMeter;
